export default class NewsDropdown {
    constructor() {
        this.dropdown = document.querySelector('.dropdown');
        this.active = false;

        if(this.dropdown) {
            let dropdownBtn = this.dropdown.querySelector('.dropdown__controls');
            let dropdownContent = this.dropdown.querySelector('.dropdown__content');

            //validating correct child elements in place.
            if(dropdownBtn === null) {
                throw new Error("NewsDropdown: Dropdown missing button (.dropdown__controls)");
            }

            if(dropdownContent === null) {
                throw new Error("NewsDropdown: Dropdown missing content (.dropdown__content)");
            }

            dropdownBtn.addEventListener('click', e => {
                this.active = !this.active;
                this.active ? this.dropdownSelected(dropdownContent, dropdownBtn) : this.dropdownDeselected(dropdownContent, dropdownBtn);
            });
            

            document.addEventListener('click', e=> {
                //if the menu is open and we have clicked outside it then close it.
                if(dropdownContent.classList.contains('active') && e.target !== this.dropdown && !e.target.closest('.dropdown')) {
                    this.active = false;
                    this.dropdownDeselected(dropdownContent, dropdownBtn);
                }
            })
        }
    }

    /**
     * 
     * @param {HTMLElement} content 
     * @param {HTMLElement} btn 
     */
    dropdownSelected(content, btn) {
        content.classList.add('active');
        btn.classList.add('active');
    }

    /**
     * 
     * @param {HTMLElement} content 
     * @param {HTMLElement} btn 
     */
    dropdownDeselected(content, btn) {
        content.classList.remove('active');
        btn.classList.remove('active');
    }
}